import type { DataColumn } from './types';

/**
 * CSV cells that a spreadsheet would treat as a formula (= + - @, tab, CR) are neutralised
 * with a leading apostrophe (RULES §SEC-4). Numbers are left alone.
 */
export function csvCell(value: unknown): string {
  if (value == null) return '';
  let s = typeof value === 'number' || typeof value === 'boolean' ? String(value) : String(value);
  if (typeof value === 'string' && /^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  if (/[",\n\r;]/.test(s)) s = `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function toCsv<T>(rows: T[], columns: DataColumn<T>[]): string {
  const cols = columns.filter((c) => c.accessor && c.csv !== false);
  const lines = [cols.map((c) => csvCell(c.header)).join(',')];
  for (const row of rows) lines.push(cols.map((c) => csvCell(c.accessor?.(row))).join(','));
  return lines.join('\r\n');
}

export function downloadCsv(filename: string, csv: string): void {
  // BOM so Excel opens UTF-8 (accents in names) correctly.
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
